import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getHiLoGamePendingBetsService,
  getCoinHeistGamePendingBetsService,
  getMineGamePendingBetsService,
  cancelBetService
} from 'network/services/pendingBets.service'

export const fetchHiLoGamePendingBets = createAsyncThunk(
  'fetch/hiLoGamePendingBets',
  async (data, thunkApi) => {
    try {
      const res = await getHiLoGamePendingBetsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchCoinHeistGamePendingBets = createAsyncThunk(
  'fetch/coinHeistGamePendingBets',
  async (data, thunkApi) => {
    try {
      const res = await getCoinHeistGamePendingBetsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchMineGamePendingBets = createAsyncThunk(
  'fetch/mineGamePendingBets',
  async (data, thunkApi) => {
    try {
      const res = await getMineGamePendingBetsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const cancelBet = createAsyncThunk(
  'cancel/bet',
  async ({ data, onSuccess }, thunkApi) => {
    try {
      const res = await cancelBetService(data)
      onSuccess && onSuccess()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
